import type { SVGProps } from "react";

export const Initials = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 41.93 41.37"
        {...props}
    >
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path d="M6.88,0V25.08L0,32V0ZM27.56,34.44v6.93H0l6.88-6.93Z" />
                <path d="M33.45,26.53l8.48,14.84H34L22,20.63l6.15.05a6.59,6.59,0,0,0,4.81-2,6.57,6.57,0,0,0,2.07-4.92A6.39,6.39,0,0,0,33,9a6.56,6.56,0,0,0-4.81-2H14.37l-.77-.78L10,0H28.18A13.26,13.26,0,0,1,37.9,4a13.36,13.36,0,0,1,4,9.72,13,13,0,0,1-2.43,7.81A13.37,13.37,0,0,1,33.45,26.53Z" />
            </g>
        </g>
    </svg>
);

export default Initials;